import { render, staticRenderFns } from "./MallFooter.vue?vue&type=template&id=f63c2742&scoped=true&"
import script from "./MallFooter.vue?vue&type=script&lang=js&"
export * from "./MallFooter.vue?vue&type=script&lang=js&"
import style0 from "./MallFooter.vue?vue&type=style&index=0&id=f63c2742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63c2742",
  null
  
)

export default component.exports